import { render, staticRenderFns } from "./VCard.vue?vue&type=template&id=aa75c8f2&"
import script from "./VCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./VCard.vue?vue&type=style&index=0&id=aa75c8f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports